/**
 * Disdetta - Fase 8, Fase 5 (evolute), preventivo 06/09/2026 (riassociazioni)
 *
 * Disdette sindacali, collegate al lavoratore.
 *
 * Tipi:
 * - INVIATA: FILCA manda disdetta ad altro sindacato (lavoratore viene da noi)
 * - RICEVUTA: altro sindacato ci manda disdetta (lavoratore lascia noi)
 * - GENERICO: disdetta ricevuta da un sindacato (siglaOrigine); sigla NULL = in attesa
 *   del file cassa, sigla NESSUNO = perfezionata (lavoratore libero)
 * - RIASSOCIATA: nel file cassa il lavoratore risulta iscritto a un sindacato diverso
 *   da quello che ha ricevuto la disdetta (sigla = nuovo sindacato,
 *   periodoRiassociazione = YYYYMM del file)
 */
import { z } from 'zod';
import { CassaCodeSchema, str } from './common.ts';

// Tipi disdetta
export const TIPI_DISDETTA = ['INVIATA', 'RICEVUTA', 'GENERICO', 'RIASSOCIATA'] as const;
export const TipoDisdettaSchema = z.enum(TIPI_DISDETTA);
export type TipoDisdetta = z.infer<typeof TipoDisdettaSchema>;

// Origini disdetta
export const ORIGINI_DISDETTA = ['MANUALE', 'IMPORT'] as const;
export const OrigineDisdettaSchema = z.enum(ORIGINI_DISDETTA);
export type OrigineDisdetta = z.infer<typeof OrigineDisdettaSchema>;

// Modalità con cui il sindacato ha ricevuto la disdetta
export const MODALITA_RICEZIONE = ['RACCOMANDATA', 'PEC', 'BANCONE'] as const;
export const ModalitaRicezioneSchema = z.enum(MODALITA_RICEZIONE);
export type ModalitaRicezione = z.infer<typeof ModalitaRicezioneSchema>;

export const DisdettaSchema = z.object({
  id: z.number(),
  lavoratoreId: z.number(),
  cassa: CassaCodeSchema,
  tipo: TipoDisdettaSchema,
  sigla: str,
  dataDisdetta: z.string(),
  note: str,
  operatore: str,
  createdAt: str,
  updatedAt: str,
  nascosta: z.number().default(0),
  delegaGenerataId: z.number().nullable().default(null),
  origine: OrigineDisdettaSchema.default('MANUALE'),
  modalitaRicezione: ModalitaRicezioneSchema.nullable().default(null),
  siglaOrigine: str.default(null),
  periodoRiassociazione: str.default(null),
});

export type Disdetta = z.infer<typeof DisdettaSchema>;

// Per INSERT (senza id, timestamp e campi gestiti dalla classificazione)
export const DisdettaInsertSchema = DisdettaSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  nascosta: true,
  delegaGenerataId: true,
  periodoRiassociazione: true,
});

export type DisdettaInsert = z.infer<typeof DisdettaInsertSchema>;
